import { createSelector } from '@ngrx/store';
import { ErrorMessage } from '../error/error-message.model';
import { provinceSelectors, ProvinceState } from './province.entity';
import { selectProvinceState } from './province.state';

export const selectProvince = createSelector(selectProvinceState, provinceSelectors.selectAll);

export const selectCatError = createSelector(
	selectProvinceState,
	(state: ProvinceState): ErrorMessage => state.error
);
